import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-editar-status-modal",
  templateUrl: "./editar-status-modal.component.html",
  styleUrls: ["./editar-status-modal.component.scss"],
})
export class EditarStatusModalComponent implements OnInit, OnChanges {
  @Input() aberto = false;
  @Input() statusAtual: number;
  @Output() salvar = new EventEmitter<number>();
  @Output() fechar = new EventEmitter<void>();

  novoStatus: number;

  ngOnInit() {
    this.novoStatus = this.statusAtual;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.statusAtual && changes.statusAtual.currentValue !== undefined) {
      this.novoStatus = changes.statusAtual.currentValue;
    }
  }

  salvarStatus() {
    this.salvar.emit(this.novoStatus);
  }
}
